/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated.index'
import { Route as AuthCallbackImport } from './routes/auth.callback'
import { Route as AuthenticatedSeonavImport } from './routes/_authenticated.seonav'
import { Route as AuthenticatedSearchImport } from './routes/_authenticated.search'
import { Route as AuthenticatedPreferencesImport } from './routes/_authenticated.preferences'
import { Route as AuthenticatedOcppImport } from './routes/_authenticated.ocpp'
import { Route as AuthenticatedNvwaImport } from './routes/_authenticated.nvwa'
import { Route as AuthenticatedNikeappImport } from './routes/_authenticated.nikeapp'
import { Route as AuthenticatedApiExplorerImport } from './routes/_authenticated.api-explorer'
import { Route as AuthenticatedApiExplorerIndexImport } from './routes/_authenticated.api-explorer.index'
import { Route as AuthenticatedSeonavUrlAnalysisImport } from './routes/_authenticated.seonav.url-analysis'
import { Route as AuthenticatedSearchQueryConsoleImport } from './routes/_authenticated.search.query-console'
import { Route as AuthenticatedSearchMongodbImport } from './routes/_authenticated.search.mongodb'
import { Route as AuthenticatedSearchIndexesImport } from './routes/_authenticated.search.indexes'
import { Route as AuthenticatedSearchForceUpdateImport } from './routes/_authenticated.search.force-update'
import { Route as AuthenticatedSearchConceptsImport } from './routes/_authenticated.search.concepts'
import { Route as AuthenticatedSearchCollectionsImport } from './routes/_authenticated.search.collections'
import { Route as AuthenticatedOcppCpaChangeHistoryImport } from './routes/_authenticated.ocpp.cpa-change-history'
import { Route as AuthenticatedNvwaNspTopicsImport } from './routes/_authenticated.nvwa.nsp-topics'
import { Route as AuthenticatedNvwaMongodbImport } from './routes/_authenticated.nvwa.mongodb'
import { Route as AuthenticatedNikeappShophomeImport } from './routes/_authenticated.nikeapp.shophome'
import { Route as AuthenticatedNikeappProductFinderImport } from './routes/_authenticated.nikeapp.product-finder'
import { Route as AuthenticatedApiExplorerServiceImport } from './routes/_authenticated.api-explorer.$service'

// Create/Update Routes

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSeonavRoute = AuthenticatedSeonavImport.update({
  id: '/seonav',
  path: '/seonav',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSearchRoute = AuthenticatedSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedPreferencesRoute = AuthenticatedPreferencesImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOcppRoute = AuthenticatedOcppImport.update({
  id: '/ocpp',
  path: '/ocpp',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedNvwaRoute = AuthenticatedNvwaImport.update({
  id: '/nvwa',
  path: '/nvwa',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedNikeappRoute = AuthenticatedNikeappImport.update({
  id: '/nikeapp',
  path: '/nikeapp',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedApiExplorerRoute = AuthenticatedApiExplorerImport.update({
  id: '/api-explorer',
  path: '/api-explorer',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedApiExplorerIndexRoute =
  AuthenticatedApiExplorerIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedApiExplorerRoute,
  } as any)

const AuthenticatedSeonavUrlAnalysisRoute =
  AuthenticatedSeonavUrlAnalysisImport.update({
    id: '/url-analysis',
    path: '/url-analysis',
    getParentRoute: () => AuthenticatedSeonavRoute,
  } as any)

const AuthenticatedSearchQueryConsoleRoute =
  AuthenticatedSearchQueryConsoleImport.update({
    id: '/query-console',
    path: '/query-console',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedSearchMongodbRoute = AuthenticatedSearchMongodbImport.update(
  {
    id: '/mongodb',
    path: '/mongodb',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any,
)

const AuthenticatedSearchIndexesRoute = AuthenticatedSearchIndexesImport.update(
  {
    id: '/indexes',
    path: '/indexes',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any,
)

const AuthenticatedSearchForceUpdateRoute =
  AuthenticatedSearchForceUpdateImport.update({
    id: '/force-update',
    path: '/force-update',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedSearchConceptsRoute =
  AuthenticatedSearchConceptsImport.update({
    id: '/concepts',
    path: '/concepts',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedSearchCollectionsRoute =
  AuthenticatedSearchCollectionsImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthenticatedSearchRoute,
  } as any)

const AuthenticatedOcppCpaChangeHistoryRoute =
  AuthenticatedOcppCpaChangeHistoryImport.update({
    id: '/cpa-change-history',
    path: '/cpa-change-history',
    getParentRoute: () => AuthenticatedOcppRoute,
  } as any)

const AuthenticatedNvwaNspTopicsRoute = AuthenticatedNvwaNspTopicsImport.update(
  {
    id: '/nsp-topics',
    path: '/nsp-topics',
    getParentRoute: () => AuthenticatedNvwaRoute,
  } as any,
)

const AuthenticatedNvwaMongodbRoute = AuthenticatedNvwaMongodbImport.update({
  id: '/mongodb',
  path: '/mongodb',
  getParentRoute: () => AuthenticatedNvwaRoute,
} as any)

const AuthenticatedNikeappShophomeRoute =
  AuthenticatedNikeappShophomeImport.update({
    id: '/shophome',
    path: '/shophome',
    getParentRoute: () => AuthenticatedNikeappRoute,
  } as any)

const AuthenticatedNikeappProductFinderRoute =
  AuthenticatedNikeappProductFinderImport.update({
    id: '/product-finder',
    path: '/product-finder',
    getParentRoute: () => AuthenticatedNikeappRoute,
  } as any)

const AuthenticatedApiExplorerServiceRoute =
  AuthenticatedApiExplorerServiceImport.update({
    id: '/$service',
    path: '/$service',
    getParentRoute: () => AuthenticatedApiExplorerRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/api-explorer': {
      id: '/_authenticated/api-explorer'
      path: '/api-explorer'
      fullPath: '/api-explorer'
      preLoaderRoute: typeof AuthenticatedApiExplorerImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/nikeapp': {
      id: '/_authenticated/nikeapp'
      path: '/nikeapp'
      fullPath: '/nikeapp'
      preLoaderRoute: typeof AuthenticatedNikeappImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/nvwa': {
      id: '/_authenticated/nvwa'
      path: '/nvwa'
      fullPath: '/nvwa'
      preLoaderRoute: typeof AuthenticatedNvwaImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/ocpp': {
      id: '/_authenticated/ocpp'
      path: '/ocpp'
      fullPath: '/ocpp'
      preLoaderRoute: typeof AuthenticatedOcppImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/preferences': {
      id: '/_authenticated/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof AuthenticatedPreferencesImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/seonav': {
      id: '/_authenticated/seonav'
      path: '/seonav'
      fullPath: '/seonav'
      preLoaderRoute: typeof AuthenticatedSeonavImport
      parentRoute: typeof AuthenticatedImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/api-explorer/$service': {
      id: '/_authenticated/api-explorer/$service'
      path: '/$service'
      fullPath: '/api-explorer/$service'
      preLoaderRoute: typeof AuthenticatedApiExplorerServiceImport
      parentRoute: typeof AuthenticatedApiExplorerImport
    }
    '/_authenticated/nikeapp/product-finder': {
      id: '/_authenticated/nikeapp/product-finder'
      path: '/product-finder'
      fullPath: '/nikeapp/product-finder'
      preLoaderRoute: typeof AuthenticatedNikeappProductFinderImport
      parentRoute: typeof AuthenticatedNikeappImport
    }
    '/_authenticated/nikeapp/shophome': {
      id: '/_authenticated/nikeapp/shophome'
      path: '/shophome'
      fullPath: '/nikeapp/shophome'
      preLoaderRoute: typeof AuthenticatedNikeappShophomeImport
      parentRoute: typeof AuthenticatedNikeappImport
    }
    '/_authenticated/nvwa/mongodb': {
      id: '/_authenticated/nvwa/mongodb'
      path: '/mongodb'
      fullPath: '/nvwa/mongodb'
      preLoaderRoute: typeof AuthenticatedNvwaMongodbImport
      parentRoute: typeof AuthenticatedNvwaImport
    }
    '/_authenticated/nvwa/nsp-topics': {
      id: '/_authenticated/nvwa/nsp-topics'
      path: '/nsp-topics'
      fullPath: '/nvwa/nsp-topics'
      preLoaderRoute: typeof AuthenticatedNvwaNspTopicsImport
      parentRoute: typeof AuthenticatedNvwaImport
    }
    '/_authenticated/ocpp/cpa-change-history': {
      id: '/_authenticated/ocpp/cpa-change-history'
      path: '/cpa-change-history'
      fullPath: '/ocpp/cpa-change-history'
      preLoaderRoute: typeof AuthenticatedOcppCpaChangeHistoryImport
      parentRoute: typeof AuthenticatedOcppImport
    }
    '/_authenticated/search/collections': {
      id: '/_authenticated/search/collections'
      path: '/collections'
      fullPath: '/search/collections'
      preLoaderRoute: typeof AuthenticatedSearchCollectionsImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/concepts': {
      id: '/_authenticated/search/concepts'
      path: '/concepts'
      fullPath: '/search/concepts'
      preLoaderRoute: typeof AuthenticatedSearchConceptsImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/force-update': {
      id: '/_authenticated/search/force-update'
      path: '/force-update'
      fullPath: '/search/force-update'
      preLoaderRoute: typeof AuthenticatedSearchForceUpdateImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/indexes': {
      id: '/_authenticated/search/indexes'
      path: '/indexes'
      fullPath: '/search/indexes'
      preLoaderRoute: typeof AuthenticatedSearchIndexesImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/mongodb': {
      id: '/_authenticated/search/mongodb'
      path: '/mongodb'
      fullPath: '/search/mongodb'
      preLoaderRoute: typeof AuthenticatedSearchMongodbImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/search/query-console': {
      id: '/_authenticated/search/query-console'
      path: '/query-console'
      fullPath: '/search/query-console'
      preLoaderRoute: typeof AuthenticatedSearchQueryConsoleImport
      parentRoute: typeof AuthenticatedSearchImport
    }
    '/_authenticated/seonav/url-analysis': {
      id: '/_authenticated/seonav/url-analysis'
      path: '/url-analysis'
      fullPath: '/seonav/url-analysis'
      preLoaderRoute: typeof AuthenticatedSeonavUrlAnalysisImport
      parentRoute: typeof AuthenticatedSeonavImport
    }
    '/_authenticated/api-explorer/': {
      id: '/_authenticated/api-explorer/'
      path: '/'
      fullPath: '/api-explorer/'
      preLoaderRoute: typeof AuthenticatedApiExplorerIndexImport
      parentRoute: typeof AuthenticatedApiExplorerImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedApiExplorerRouteChildren {
  AuthenticatedApiExplorerServiceRoute: typeof AuthenticatedApiExplorerServiceRoute
  AuthenticatedApiExplorerIndexRoute: typeof AuthenticatedApiExplorerIndexRoute
}

const AuthenticatedApiExplorerRouteChildren: AuthenticatedApiExplorerRouteChildren =
  {
    AuthenticatedApiExplorerServiceRoute: AuthenticatedApiExplorerServiceRoute,
    AuthenticatedApiExplorerIndexRoute: AuthenticatedApiExplorerIndexRoute,
  }

const AuthenticatedApiExplorerRouteWithChildren =
  AuthenticatedApiExplorerRoute._addFileChildren(
    AuthenticatedApiExplorerRouteChildren,
  )

interface AuthenticatedNikeappRouteChildren {
  AuthenticatedNikeappProductFinderRoute: typeof AuthenticatedNikeappProductFinderRoute
  AuthenticatedNikeappShophomeRoute: typeof AuthenticatedNikeappShophomeRoute
}

const AuthenticatedNikeappRouteChildren: AuthenticatedNikeappRouteChildren = {
  AuthenticatedNikeappProductFinderRoute:
    AuthenticatedNikeappProductFinderRoute,
  AuthenticatedNikeappShophomeRoute: AuthenticatedNikeappShophomeRoute,
}

const AuthenticatedNikeappRouteWithChildren =
  AuthenticatedNikeappRoute._addFileChildren(AuthenticatedNikeappRouteChildren)

interface AuthenticatedNvwaRouteChildren {
  AuthenticatedNvwaMongodbRoute: typeof AuthenticatedNvwaMongodbRoute
  AuthenticatedNvwaNspTopicsRoute: typeof AuthenticatedNvwaNspTopicsRoute
}

const AuthenticatedNvwaRouteChildren: AuthenticatedNvwaRouteChildren = {
  AuthenticatedNvwaMongodbRoute: AuthenticatedNvwaMongodbRoute,
  AuthenticatedNvwaNspTopicsRoute: AuthenticatedNvwaNspTopicsRoute,
}

const AuthenticatedNvwaRouteWithChildren =
  AuthenticatedNvwaRoute._addFileChildren(AuthenticatedNvwaRouteChildren)

interface AuthenticatedOcppRouteChildren {
  AuthenticatedOcppCpaChangeHistoryRoute: typeof AuthenticatedOcppCpaChangeHistoryRoute
}

const AuthenticatedOcppRouteChildren: AuthenticatedOcppRouteChildren = {
  AuthenticatedOcppCpaChangeHistoryRoute:
    AuthenticatedOcppCpaChangeHistoryRoute,
}

const AuthenticatedOcppRouteWithChildren =
  AuthenticatedOcppRoute._addFileChildren(AuthenticatedOcppRouteChildren)

interface AuthenticatedSearchRouteChildren {
  AuthenticatedSearchCollectionsRoute: typeof AuthenticatedSearchCollectionsRoute
  AuthenticatedSearchConceptsRoute: typeof AuthenticatedSearchConceptsRoute
  AuthenticatedSearchForceUpdateRoute: typeof AuthenticatedSearchForceUpdateRoute
  AuthenticatedSearchIndexesRoute: typeof AuthenticatedSearchIndexesRoute
  AuthenticatedSearchMongodbRoute: typeof AuthenticatedSearchMongodbRoute
  AuthenticatedSearchQueryConsoleRoute: typeof AuthenticatedSearchQueryConsoleRoute
}

const AuthenticatedSearchRouteChildren: AuthenticatedSearchRouteChildren = {
  AuthenticatedSearchCollectionsRoute: AuthenticatedSearchCollectionsRoute,
  AuthenticatedSearchConceptsRoute: AuthenticatedSearchConceptsRoute,
  AuthenticatedSearchForceUpdateRoute: AuthenticatedSearchForceUpdateRoute,
  AuthenticatedSearchIndexesRoute: AuthenticatedSearchIndexesRoute,
  AuthenticatedSearchMongodbRoute: AuthenticatedSearchMongodbRoute,
  AuthenticatedSearchQueryConsoleRoute: AuthenticatedSearchQueryConsoleRoute,
}

const AuthenticatedSearchRouteWithChildren =
  AuthenticatedSearchRoute._addFileChildren(AuthenticatedSearchRouteChildren)

interface AuthenticatedSeonavRouteChildren {
  AuthenticatedSeonavUrlAnalysisRoute: typeof AuthenticatedSeonavUrlAnalysisRoute
}

const AuthenticatedSeonavRouteChildren: AuthenticatedSeonavRouteChildren = {
  AuthenticatedSeonavUrlAnalysisRoute: AuthenticatedSeonavUrlAnalysisRoute,
}

const AuthenticatedSeonavRouteWithChildren =
  AuthenticatedSeonavRoute._addFileChildren(AuthenticatedSeonavRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedApiExplorerRoute: typeof AuthenticatedApiExplorerRouteWithChildren
  AuthenticatedNikeappRoute: typeof AuthenticatedNikeappRouteWithChildren
  AuthenticatedNvwaRoute: typeof AuthenticatedNvwaRouteWithChildren
  AuthenticatedOcppRoute: typeof AuthenticatedOcppRouteWithChildren
  AuthenticatedPreferencesRoute: typeof AuthenticatedPreferencesRoute
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRouteWithChildren
  AuthenticatedSeonavRoute: typeof AuthenticatedSeonavRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedApiExplorerRoute: AuthenticatedApiExplorerRouteWithChildren,
  AuthenticatedNikeappRoute: AuthenticatedNikeappRouteWithChildren,
  AuthenticatedNvwaRoute: AuthenticatedNvwaRouteWithChildren,
  AuthenticatedOcppRoute: AuthenticatedOcppRouteWithChildren,
  AuthenticatedPreferencesRoute: AuthenticatedPreferencesRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRouteWithChildren,
  AuthenticatedSeonavRoute: AuthenticatedSeonavRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/api-explorer': typeof AuthenticatedApiExplorerRouteWithChildren
  '/nikeapp': typeof AuthenticatedNikeappRouteWithChildren
  '/nvwa': typeof AuthenticatedNvwaRouteWithChildren
  '/ocpp': typeof AuthenticatedOcppRouteWithChildren
  '/preferences': typeof AuthenticatedPreferencesRoute
  '/search': typeof AuthenticatedSearchRouteWithChildren
  '/seonav': typeof AuthenticatedSeonavRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/nikeapp/product-finder': typeof AuthenticatedNikeappProductFinderRoute
  '/nikeapp/shophome': typeof AuthenticatedNikeappShophomeRoute
  '/nvwa/mongodb': typeof AuthenticatedNvwaMongodbRoute
  '/nvwa/nsp-topics': typeof AuthenticatedNvwaNspTopicsRoute
  '/ocpp/cpa-change-history': typeof AuthenticatedOcppCpaChangeHistoryRoute
  '/search/collections': typeof AuthenticatedSearchCollectionsRoute
  '/search/concepts': typeof AuthenticatedSearchConceptsRoute
  '/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/search/mongodb': typeof AuthenticatedSearchMongodbRoute
  '/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/seonav/url-analysis': typeof AuthenticatedSeonavUrlAnalysisRoute
  '/api-explorer/': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/nikeapp': typeof AuthenticatedNikeappRouteWithChildren
  '/nvwa': typeof AuthenticatedNvwaRouteWithChildren
  '/ocpp': typeof AuthenticatedOcppRouteWithChildren
  '/preferences': typeof AuthenticatedPreferencesRoute
  '/search': typeof AuthenticatedSearchRouteWithChildren
  '/seonav': typeof AuthenticatedSeonavRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AuthenticatedIndexRoute
  '/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/nikeapp/product-finder': typeof AuthenticatedNikeappProductFinderRoute
  '/nikeapp/shophome': typeof AuthenticatedNikeappShophomeRoute
  '/nvwa/mongodb': typeof AuthenticatedNvwaMongodbRoute
  '/nvwa/nsp-topics': typeof AuthenticatedNvwaNspTopicsRoute
  '/ocpp/cpa-change-history': typeof AuthenticatedOcppCpaChangeHistoryRoute
  '/search/collections': typeof AuthenticatedSearchCollectionsRoute
  '/search/concepts': typeof AuthenticatedSearchConceptsRoute
  '/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/search/mongodb': typeof AuthenticatedSearchMongodbRoute
  '/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/seonav/url-analysis': typeof AuthenticatedSeonavUrlAnalysisRoute
  '/api-explorer': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_authenticated/api-explorer': typeof AuthenticatedApiExplorerRouteWithChildren
  '/_authenticated/nikeapp': typeof AuthenticatedNikeappRouteWithChildren
  '/_authenticated/nvwa': typeof AuthenticatedNvwaRouteWithChildren
  '/_authenticated/ocpp': typeof AuthenticatedOcppRouteWithChildren
  '/_authenticated/preferences': typeof AuthenticatedPreferencesRoute
  '/_authenticated/search': typeof AuthenticatedSearchRouteWithChildren
  '/_authenticated/seonav': typeof AuthenticatedSeonavRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/api-explorer/$service': typeof AuthenticatedApiExplorerServiceRoute
  '/_authenticated/nikeapp/product-finder': typeof AuthenticatedNikeappProductFinderRoute
  '/_authenticated/nikeapp/shophome': typeof AuthenticatedNikeappShophomeRoute
  '/_authenticated/nvwa/mongodb': typeof AuthenticatedNvwaMongodbRoute
  '/_authenticated/nvwa/nsp-topics': typeof AuthenticatedNvwaNspTopicsRoute
  '/_authenticated/ocpp/cpa-change-history': typeof AuthenticatedOcppCpaChangeHistoryRoute
  '/_authenticated/search/collections': typeof AuthenticatedSearchCollectionsRoute
  '/_authenticated/search/concepts': typeof AuthenticatedSearchConceptsRoute
  '/_authenticated/search/force-update': typeof AuthenticatedSearchForceUpdateRoute
  '/_authenticated/search/indexes': typeof AuthenticatedSearchIndexesRoute
  '/_authenticated/search/mongodb': typeof AuthenticatedSearchMongodbRoute
  '/_authenticated/search/query-console': typeof AuthenticatedSearchQueryConsoleRoute
  '/_authenticated/seonav/url-analysis': typeof AuthenticatedSeonavUrlAnalysisRoute
  '/_authenticated/api-explorer/': typeof AuthenticatedApiExplorerIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/logout'
    | '/api-explorer'
    | '/nikeapp'
    | '/nvwa'
    | '/ocpp'
    | '/preferences'
    | '/search'
    | '/seonav'
    | '/auth/callback'
    | '/'
    | '/api-explorer/$service'
    | '/nikeapp/product-finder'
    | '/nikeapp/shophome'
    | '/nvwa/mongodb'
    | '/nvwa/nsp-topics'
    | '/ocpp/cpa-change-history'
    | '/search/collections'
    | '/search/concepts'
    | '/search/force-update'
    | '/search/indexes'
    | '/search/mongodb'
    | '/search/query-console'
    | '/seonav/url-analysis'
    | '/api-explorer/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/nikeapp'
    | '/nvwa'
    | '/ocpp'
    | '/preferences'
    | '/search'
    | '/seonav'
    | '/auth/callback'
    | '/'
    | '/api-explorer/$service'
    | '/nikeapp/product-finder'
    | '/nikeapp/shophome'
    | '/nvwa/mongodb'
    | '/nvwa/nsp-topics'
    | '/ocpp/cpa-change-history'
    | '/search/collections'
    | '/search/concepts'
    | '/search/force-update'
    | '/search/indexes'
    | '/search/mongodb'
    | '/search/query-console'
    | '/seonav/url-analysis'
    | '/api-explorer'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/logout'
    | '/_authenticated/api-explorer'
    | '/_authenticated/nikeapp'
    | '/_authenticated/nvwa'
    | '/_authenticated/ocpp'
    | '/_authenticated/preferences'
    | '/_authenticated/search'
    | '/_authenticated/seonav'
    | '/auth/callback'
    | '/_authenticated/'
    | '/_authenticated/api-explorer/$service'
    | '/_authenticated/nikeapp/product-finder'
    | '/_authenticated/nikeapp/shophome'
    | '/_authenticated/nvwa/mongodb'
    | '/_authenticated/nvwa/nsp-topics'
    | '/_authenticated/ocpp/cpa-change-history'
    | '/_authenticated/search/collections'
    | '/_authenticated/search/concepts'
    | '/_authenticated/search/force-update'
    | '/_authenticated/search/indexes'
    | '/_authenticated/search/mongodb'
    | '/_authenticated/search/query-console'
    | '/_authenticated/seonav/url-analysis'
    | '/_authenticated/api-explorer/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/login",
        "/logout",
        "/auth/callback"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/api-explorer",
        "/_authenticated/nikeapp",
        "/_authenticated/nvwa",
        "/_authenticated/ocpp",
        "/_authenticated/preferences",
        "/_authenticated/search",
        "/_authenticated/seonav",
        "/_authenticated/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/_authenticated/api-explorer": {
      "filePath": "_authenticated.api-explorer.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/api-explorer/$service",
        "/_authenticated/api-explorer/"
      ]
    },
    "/_authenticated/nikeapp": {
      "filePath": "_authenticated.nikeapp.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/nikeapp/product-finder",
        "/_authenticated/nikeapp/shophome"
      ]
    },
    "/_authenticated/nvwa": {
      "filePath": "_authenticated.nvwa.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/nvwa/mongodb",
        "/_authenticated/nvwa/nsp-topics"
      ]
    },
    "/_authenticated/ocpp": {
      "filePath": "_authenticated.ocpp.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/ocpp/cpa-change-history"
      ]
    },
    "/_authenticated/preferences": {
      "filePath": "_authenticated.preferences.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/search": {
      "filePath": "_authenticated.search.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/search/collections",
        "/_authenticated/search/concepts",
        "/_authenticated/search/force-update",
        "/_authenticated/search/indexes",
        "/_authenticated/search/mongodb",
        "/_authenticated/search/query-console"
      ]
    },
    "/_authenticated/seonav": {
      "filePath": "_authenticated.seonav.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/seonav/url-analysis"
      ]
    },
    "/auth/callback": {
      "filePath": "auth.callback.tsx"
    },
    "/_authenticated/": {
      "filePath": "_authenticated.index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/api-explorer/$service": {
      "filePath": "_authenticated.api-explorer.$service.tsx",
      "parent": "/_authenticated/api-explorer"
    },
    "/_authenticated/nikeapp/product-finder": {
      "filePath": "_authenticated.nikeapp.product-finder.tsx",
      "parent": "/_authenticated/nikeapp"
    },
    "/_authenticated/nikeapp/shophome": {
      "filePath": "_authenticated.nikeapp.shophome.tsx",
      "parent": "/_authenticated/nikeapp"
    },
    "/_authenticated/nvwa/mongodb": {
      "filePath": "_authenticated.nvwa.mongodb.tsx",
      "parent": "/_authenticated/nvwa"
    },
    "/_authenticated/nvwa/nsp-topics": {
      "filePath": "_authenticated.nvwa.nsp-topics.tsx",
      "parent": "/_authenticated/nvwa"
    },
    "/_authenticated/ocpp/cpa-change-history": {
      "filePath": "_authenticated.ocpp.cpa-change-history.tsx",
      "parent": "/_authenticated/ocpp"
    },
    "/_authenticated/search/collections": {
      "filePath": "_authenticated.search.collections.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/concepts": {
      "filePath": "_authenticated.search.concepts.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/force-update": {
      "filePath": "_authenticated.search.force-update.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/indexes": {
      "filePath": "_authenticated.search.indexes.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/mongodb": {
      "filePath": "_authenticated.search.mongodb.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/search/query-console": {
      "filePath": "_authenticated.search.query-console.tsx",
      "parent": "/_authenticated/search"
    },
    "/_authenticated/seonav/url-analysis": {
      "filePath": "_authenticated.seonav.url-analysis.tsx",
      "parent": "/_authenticated/seonav"
    },
    "/_authenticated/api-explorer/": {
      "filePath": "_authenticated.api-explorer.index.tsx",
      "parent": "/_authenticated/api-explorer"
    }
  }
}
ROUTE_MANIFEST_END */
